import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const FindLand = () => {

    const MIN_PRICE = 10;
    const MAX_PRICE = 500;
    const STEP = 10;

    const [minVal, setMinVal] = useState(MIN_PRICE);
    const [maxVal, setMaxVal] = useState(MAX_PRICE);

    const sliderRef = useRef(null);
    const popupMinRef = useRef(null);
    const popupMaxRef = useRef(null);

    const updatePositions = () => {
        if (!sliderRef.current || !popupMinRef.current || !popupMaxRef.current) return;

        let min = Math.min(minVal, maxVal);
        let max = Math.max(minVal, maxVal);

        const totalRange = MAX_PRICE - MIN_PRICE;
        const minPercent = ((min - MIN_PRICE) / totalRange) * 100;
        const maxPercent = ((max - MIN_PRICE) / totalRange) * 100;

        sliderRef.current.style.setProperty("--min-val", `${minPercent}%`);
        sliderRef.current.style.setProperty("--max-val", `${maxPercent}%`);

        const sliderWidth = sliderRef.current.offsetWidth;

        let minPos = (minPercent / 100) * sliderWidth;
        minPos = Math.max(minPos - popupMinRef.current.offsetWidth / 2, 0);
        minPos = Math.min(minPos, sliderWidth - popupMinRef.current.offsetWidth - 20);
        popupMinRef.current.style.left = `${minPos}px`;

        let maxPos = (maxPercent / 100) * sliderWidth;
        maxPos = maxPos - popupMaxRef.current.offsetWidth / 2;
        maxPos = Math.min(maxPos, sliderWidth - popupMaxRef.current.offsetWidth);
        maxPos = Math.max(maxPos, 20);
        popupMaxRef.current.style.left = `${maxPos}px`;
    };

    useEffect(() => {
        updatePositions();
        window.addEventListener("resize", updatePositions);
        return () => window.removeEventListener("resize", updatePositions);
    }, [minVal, maxVal]);

    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Find Land</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="service all-section detl_pgg">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInDown" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="heading">
                                <h2>Available Allotments</h2>
                                <p>Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut enim ad
                                    minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                    incididunt</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-4">
                            <div className="product-bar">
                                <div className="range-bg-space">
                                    <h5>Price Filter</h5>
                                    <div className="range-slider" ref={sliderRef}>
                                        <div className="slider-track" />
                                        <div className="rangeValues">
                                            <div id="popup-min" ref={popupMinRef} className="value-popup">
                                                ${minVal.toLocaleString()}
                                            </div>
                                            <div id="popup-max" ref={popupMaxRef} className="value-popup left-side-one">
                                                ${maxVal.toLocaleString()}
                                            </div>
                                        </div>

                                        <div className="show-top text-sm font-medium text-gray-500 flex justify-between w-100">
                                            <div>Min: ${minVal.toLocaleString()}</div>
                                            <div>Max: ${maxVal.toLocaleString()}</div>
                                        </div>

                                        <input
                                            id="min"
                                            type="range"
                                            min={MIN_PRICE}
                                            max={MAX_PRICE}
                                            step={STEP}
                                            value={minVal}
                                            onChange={(e) => setMinVal(Number(e.target.value))}
                                        />
                                        <input
                                            id="max"
                                            type="range"
                                            min={MIN_PRICE}
                                            max={MAX_PRICE}
                                            step={STEP}
                                            value={maxVal}
                                            onChange={(e) => setMaxVal(Number(e.target.value))}
                                        />
                                    </div>
                                </div>
                                <div className="product-bar1">
                                    <h5>SQM by Category</h5>
                                    <Link to="#">100 sqm</Link>
                                    <Link to="#">120 sqm</Link>
                                    <Link to="#">150 sqm</Link>
                                    <Link to="#">200 sqm</Link>
                                    <Link to="#">220 sqm</Link>
                                    <Link to="#">250 sqm</Link>
                                    <Link to="#">500 sqm</Link>
                                    <Link to="#">1000 sqm</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-8">
                            <div className="row right-side-top align-items-center mb-5">
                                <div className="col-md-9">
                                    <form>
                                        <input type="search" placeholder="Search by Location" name id />
                                        <button type="submit"><i className="fa-solid fa-magnifying-glass" /></button>
                                    </form>
                                </div>
                                <div className="col-md-3">
                                    <div className="show-prg-num d-flex align-items-center ">
                                        <p>Show:</p>
                                        <div>
                                            <Link to="#">6</Link>
                                            <Link to="#">24</Link>
                                            <Link to="#">40</Link>
                                            <Link to="#">60</Link>
                                            <Link to="#">80</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                                    <div className="service_main">
                                        <img src="images/s-1.jpg" alt />
                                        <div className="svr_no">
                                            01
                                        </div>
                                        <div className="service_txt">
                                            <h3>Organic Farming Land</h3>
                                            <p>Lorem ipsum dolor sit amet..</p>
                                            <ul className="srv_disnone">
                                                <li>
                                                    <img src="images/full-size.png" alt />
                                                    <span>
                                                        100 – 250 sqm
                                                    </span>
                                                </li>
                                                <li>
                                                    <img src="images/location.png" alt />
                                                    <span>
                                                        Demo Allotment Plot 2....
                                                    </span>
                                                </li>
                                            </ul>
                                            <Link to="/find-land-detail" className="srv_btn">
                                                <span>
                                                    MOre Detail
                                                </span>
                                                <img src="images/btn-img2.png" alt />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.5s" data-wow-duration="2s">
                                    <div className="service_main">
                                        <img src="images/s-2.jpg" alt />
                                        <div className="svr_no">
                                            02
                                        </div>
                                        <div className="service_txt">
                                            <h3>Large Agricultural Land</h3>
                                            <p>Lorem ipsum dolor sit amet..</p>
                                            <ul className="srv_disnone">
                                                <li>
                                                    <img src="images/full-size.png" alt />
                                                    <span>
                                                        100 – 250 sqm
                                                    </span>
                                                </li>
                                                <li>
                                                    <img src="images/location.png" alt />
                                                    <span>Demo Allotment Plot 2....</span>
                                                </li>
                                            </ul>
                                            <Link to="/find-land-detail" className="srv_btn">
                                                <span>
                                                    MOre Detail
                                                </span>
                                                <img src="images/btn-img2.png" alt />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="2s">
                                    <div className="service_main">
                                        <img src="images/s-3.jpg" alt />
                                        <div className="svr_no">
                                            03
                                        </div>
                                        <div className="service_txt">
                                            <h3>Vineyard Ready Land</h3>
                                            <p>Lorem ipsum dolor sit amet..</p>
                                            <ul className="srv_disnone">
                                                <li>
                                                    <img src="images/full-size.png" alt />
                                                    <span>
                                                        100 – 250 sqm
                                                    </span>
                                                </li>
                                                <li>
                                                    <img src="images/location.png" alt />
                                                    <span>
                                                        Demo Allotment Plot 2....
                                                    </span>
                                                </li>
                                            </ul>
                                            <Link to="/find-land-detail" className="srv_btn">
                                                <span>
                                                    MOre Detail
                                                </span>
                                                <img src="images/btn-img2.png" alt />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                                    <div className="service_main">
                                        <img src="images/s-4.jpg" alt />
                                        <div className="svr_no">
                                            04
                                        </div>
                                        <div className="service_txt">
                                            <h3>Open Grazing Land</h3>
                                            <p>Lorem ipsum dolor sit amet..</p>
                                            <ul className="srv_disnone">
                                                <li>
                                                    <img src="images/full-size.png" alt />
                                                    <span>
                                                        100 – 250 sqm
                                                    </span>
                                                </li>
                                                <li>
                                                    <img src="images/location.png" alt />
                                                    <span>
                                                        Demo Allotment Plot 2....
                                                    </span>
                                                </li>
                                            </ul>
                                            <Link to="/find-land-detail" className="srv_btn">
                                                <span>
                                                    MOre Detail
                                                </span>
                                                <img src="images/btn-img2.png" alt />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.5s" data-wow-duration="2s">
                                    <div className="service_main">
                                        <img src="images/s-5.jpg" alt />
                                        <div className="svr_no">
                                            05
                                        </div>
                                        <div className="service_txt">
                                            <h3>Small Starter Farm Land</h3>
                                            <p>Lorem ipsum dolor sit amet..</p>
                                            <ul className="srv_disnone">
                                                <li>
                                                    <img src="images/full-size.png" alt />
                                                    <span>
                                                        100 – 250 sqm
                                                    </span>
                                                </li>
                                                <li>
                                                    <img src="images/location.png" alt />
                                                    <span>
                                                        Demo Allotment Plot 2....
                                                    </span>
                                                </li>
                                            </ul>
                                            <Link to="/find-land-detail" className="srv_btn">
                                                <span>
                                                    MOre Detail
                                                </span>
                                                <img src="images/btn-img2.png" alt />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="2s">
                                    <div className="service_main">
                                        <img src="images/s-6.jpg" alt />
                                        <div className="svr_no">
                                            06
                                        </div>
                                        <div className="service_txt">
                                            <h3>Large Starter Farm Land</h3>
                                            <p>Lorem ipsum dolor sit amet..</p>
                                            <ul className="srv_disnone">
                                                <li>
                                                    <img src="images/full-size.png" alt />
                                                    <span>
                                                        100 – 250 sqm
                                                    </span>
                                                </li>
                                                <li>
                                                    <img src="images/location.png" alt />
                                                    <span>
                                                        Demo Allotment Plot 2....
                                                    </span>
                                                </li>
                                            </ul>
                                            <Link to="/find-land-detail" className="srv_btn">
                                                <span>
                                                    MOre Detail
                                                </span>
                                                <img src="images/btn-img2.png" alt />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default FindLand